import { render } from "./MenuBar.vue?vue&type=template&id=ca17cc8a&scoped=true"
import script from "./MenuBar.vue?vue&type=script&lang=js"
export * from "./MenuBar.vue?vue&type=script&lang=js"

import "./MenuBar.vue?vue&type=style&index=0&id=ca17cc8a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ca17cc8a"]])

export default __exports__